import React from 'react';
import { USERS } from './data';
interface AvatarProps {
  uid: string;
  size?: number;
  ring?: boolean;
}
export function Avatar({
  uid,
  size = 26,
  ring
}: AvatarProps) {
  const u = USERS[uid];
  if (!u) return null;
  return <div style={{
    position: 'relative',
    width: size,
    height: size,
    flexShrink: 0
  }} title={u.name} data-id="element-70">
      <div style={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: u.color,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size * 0.36,
      fontWeight: 700,
      color: 'white',
      border: ring ? '2px solid white' : 'none',
      boxShadow: ring ? `0 0 0 1.5px ${u.color}` : 'none'
    }} data-id="element-71">
        {u.initials}
      </div>
    </div>;
}
interface AvatarStackProps {
  uids: string[];
}
export function AvatarStack({
  uids
}: AvatarStackProps) {
  return <div style={{
    display: 'flex'
  }} data-id="element-72">
      {uids.map((id, i) => <div key={id} style={{
      marginLeft: i ? -6 : 0,
      zIndex: uids.length - i
    }} data-id="element-73">
          <Avatar uid={id} size={22} ring data-id="element-74" />
        </div>)}
    </div>;
}